export const calculators = [
    {
        name: "SIP",
        link: "/calculators/sip-calculator",
        image: "/images/calculators/sip_icon.svg",
        description: "Calculate how much to invest monthly to reach your financial goals."
    },
    {
        name: "Personal Loan EMI",
        link: "/calculators/personal-loan-emi-calculator",
        image: "/images/calculators/personal_loan_icon.svg",
        description: "Estimate your personal loan EMI and loan details to fulfill your goals."
    },
    {
        name: "Car Loan EMI",
        link: "/calculators/car-loan-emi-calculator",
        image: "/images/calculators/car_loan_icon.svg",
        description: "Estimate your EMI and loan details for purchasing your dream car."
    },
    {
        name: "Home Loan EMI",
        link: "/calculators/home-loan-emi-calculator",
        image: "/images/calculators/home_loan_icon.svg",
        description: "Calculate your EMI for purchasing your dream home.",
    },
    {
        name: "Education Corpus",
        link: "/calculators/child-education-plan-calculator",
        image: "/images/calculators/education_corpus_icon.svg",
        description: "Estimate the amount you need to save for your child's higher education."
    },
    {
        name: "Marriage Corpus",
        link: "/calculators/marriage-calculator",
        image: "/images/calculators/marriage_corpus_icon.svg",
        description: "Estimate the amount you need to save for your marriage.",
    },
];

export const calculatorSlugs = {
    "SIP_CALCULATOR": "sip-calculator",
    "PERSONAL_LOAN_EMI_CALCULATOR": "personal-loan-emi-calculator",
    "CAR_LOAN_EMI_CALCULATOR": "car-loan-emi-calculator",
    "HOME_LOAN_EMI_CALCULATOR": "home-loan-emi-calculator",
    "EDUCATION_CORPUS_CALCULATOR": "child-education-plan-calculator",
    "MARRIAGE_CORPUS_CALCULATOR": "marriage-calculator",
    "FD_CALCULATOR": "fd-calculator",
};

export const calculatorBreadcrumb = [
    { title: 'Home', url: '/' },
    {
        title: `Calculators`,
        url: `/calculators`,
    },
];

export const calculatorListingBreadcrumb = [
    { title: 'Home', url: '/' },
    {
        title: `Calculators`,
        active: true
    },
];
